"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = require("react");
var _EnvContext = require("../../Env/EnvContext");
var _API = require("../../API");
var useAdministrativeTenant = function useAdministrativeTenant() {
  var _useContext = (0, _react.useContext)(_API.RestAPIContext),
    tenantName = _useContext.tenantName;
  var _useContext2 = (0, _react.useContext)(_EnvContext.EnvContext),
    administrativeTenantName = _useContext2.administrativePlantName;
  return (0, _react.useMemo)(function () {
    return !!(administrativeTenantName && tenantName && administrativeTenantName === tenantName);
  }, [administrativeTenantName, tenantName]);
};
var _default = exports["default"] = useAdministrativeTenant;